import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ShieldCheck } from "@phosphor-icons/react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Kata sandi minimal 6 karakter"); return; }
    if (pw !== pw2) { toast.error("Konfirmasi kata sandi tidak sama"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Kata sandi berhasil diubah. Silakan masuk.");
      navigate("/login");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen app-bg flex justify-center">
      <div className="w-full md:max-w-md min-h-screen flex flex-col px-6 py-10">
        <div className="flex flex-col items-center mt-8 mb-8">
          <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center shadow-lg">
            <ShieldCheck size={30} weight="fill" className="text-secondary" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-stone-800 mt-4">Atur Ulang Kata Sandi</h1>
          <p className="text-stone-500 text-sm text-center mt-1">Buat kata sandi baru untuk akun Anda</p>
        </div>

        {!token ? (
          <div className="bg-white border border-stone-200 rounded-2xl p-5 text-center" data-testid="reset-invalid">
            <p className="text-stone-600 text-sm">Tautan tidak valid. Silakan minta ulang tautan reset.</p>
            <Link to="/lupa-password" className="inline-block mt-4 text-primary font-semibold text-sm">Minta Ulang</Link>
          </div>
        ) : (
          <motion.form initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} onSubmit={submit} className="space-y-4">
            <div className="relative">
              <Lock size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" />
              <input data-testid="reset-pw-input" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                placeholder="Kata sandi baru"
                className="w-full bg-white border border-stone-200 rounded-2xl py-4 pl-12 pr-4 outline-none focus:border-primary transition-colors" />
            </div>
            <div className="relative">
              <Lock size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" />
              <input data-testid="reset-pw2-input" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
                placeholder="Ulangi kata sandi baru"
                className="w-full bg-white border border-stone-200 rounded-2xl py-4 pl-12 pr-4 outline-none focus:border-primary transition-colors" />
            </div>
            <button data-testid="reset-submit-btn" disabled={loading}
              className="w-full bg-primary text-white font-heading font-semibold text-lg py-4 rounded-full shadow-lg shadow-primary/20 active:scale-95 transition-transform disabled:opacity-60">
              {loading ? "Menyimpan..." : "Simpan Kata Sandi"}
            </button>
          </motion.form>
        )}
      </div>
    </div>
  );
}
